import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let location_uuid = useDataValue({
    context: 'automation',
    path: 'location_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_uuid,
    },
  }
}
